import axios from "axios";
import { getCookie } from "../../utils";

import { API_BASE_PATH } from "../../const";


const getActiveSubscriptions = () => {
    
    return axios
        .get(API_BASE_PATH + `dashboard/active_subscriptions/`, {
            headers: {
                'X-CSRFToken': getCookie("csrftoken"),
            }
        })
        .then((response) => {
            return response.data;
        });
};

const getFailingSubscriptions = () => {
    
    return axios
        .get(API_BASE_PATH + `dashboard/failing_subscriptions/`, {
            headers: {
                'X-CSRFToken': getCookie("csrftoken"),
            }
        })
        .then((response) => {
            return response.data;
        });
};

const getNewSubscriptions = () => {
    
    return axios
        .get(API_BASE_PATH + `dashboard/new_subscriptions/`, {
            headers: {
                'X-CSRFToken': getCookie("csrftoken"),
            }
        })
        .then((response) => {
            return response.data;
        });
};

const getChurn = () => {
    
    return axios
        .get(API_BASE_PATH + `dashboard/churn/`, {
            headers: {
                'X-CSRFToken': getCookie("csrftoken"),
            }
        })
        .then((response) => {
            return response.data;
        });
};

const getTotalSales = () => {
    
    return axios
        .get(API_BASE_PATH + `dashboard/total_sales/`, {
            headers: {
                'X-CSRFToken': getCookie("csrftoken"),
            }
        })
        .then((response) => {
            return response.data;
        });
};

const getTotalSalesByMonth = () => {
    
    return axios
        .get(API_BASE_PATH + `dashboard/total_sales_by_month/`, {
            headers: {
                'X-CSRFToken': getCookie("csrftoken"),
            }
        })
        .then((response) => {
            return response.data;
        });
};


const DashboardService = {
    getActiveSubscriptions,
    getFailingSubscriptions,
    getNewSubscriptions,
    getChurn,
    getTotalSales,
    getTotalSalesByMonth,
};

export default DashboardService;